import { useLocation } from 'react-router-dom';
import { useState } from 'react';

import Title from '../../../components/Title';
import MyContents from '../../../components/MyContents';
import Pagination from '../../../components/Pagination';

function PublishedContents() {
  const location = useLocation();
  const contentsType = location.state.isMobile ? '모바일' : 'PC';
  const publishedContents = location.state.publishedContents;

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 4;
  const lastIndex = currentPage * itemsPerPage;
  const firstIndex = lastIndex - itemsPerPage;
  const currentItems = publishedContents.slice(firstIndex, lastIndex);

  return (
    <div>
      <Title title={`${contentsType}_게시된 콘텐츠`} />

      <div
        style={{
          marginTop: 30,
          display: 'flex',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
        }}
      >
        {currentItems.map((content) => (
          <MyContents
            key={content.contentsNo}
            title={content.title}
            thumbnail={content.thumbnail}
            completeYn={1}
            productCount={content.itemCount}
            date={content.updateDate}
            style={content.style}
            contentsType={contentsType}
            isPublished={true}
          />
        ))}
      </div>

      <div
        style={{
          position: 'absolute',
          bottom: 70,
          left: '50%',
          transform: 'translateX(-50%)',
        }}
      >
        <Pagination
          itemsPerPage={itemsPerPage}
          totalItems={publishedContents.length}
          paginate={setCurrentPage}
          currentPage={currentPage}
        />
      </div>
    </div>
  );
}

export default PublishedContents;
